import React, { useState } from 'react';
import {
  FDBox,
} from '@facet-wealth/design';
import { useSnackbarContext } from 'Context/SnackbarContext';
import PlannerTransitionTableFilters
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters';
import PlannerTransitionTableContent
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableContent';
import {
  useItemListContext,
} from 'Views/Page/Content/Templates/GenericTableTemplate/MainContent/ItemListPicker/ItemList/ItemContext';

const PlannerTransitionTable = () => {
  const [loadingPrevOrNextPage, setLoadingPrevOrNextPage] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const {
    loading: plannerTransitionHouseholdSummaryLoading,
    loadingError: plannerTransitionHouseholdSummaryLoadingError,
    getNextPage: loadPlannerTransitionHouseholdSummaryNextPage,
    getPrevPage: loadPlannerTransitionHouseholdSummaryPreviousPage,
    itemsCollection: plannerTransitionHouseholdSummaryCollection,
    setItemsCollection: setPlannerTransitionHouseholdSummaryCollection,
    pageNumber: currentPageNumber,
  } = useItemListContext();

  const handlePaginationChange = async (event, newPageNumber) => {
    setLoadingPrevOrNextPage(true);
    try {
      if (newPageNumber > currentPageNumber) {
        await loadPlannerTransitionHouseholdSummaryNextPage(plannerTransitionHouseholdSummaryCollection);
      }

      if (newPageNumber < currentPageNumber) {
        await loadPlannerTransitionHouseholdSummaryPreviousPage(plannerTransitionHouseholdSummaryCollection);
      }
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: Failed to change page, please try again');
      }
    } finally {
      setLoadingPrevOrNextPage(false);
    }
  };

  return (
    <FDBox>
      <PlannerTransitionTableFilters
        plannerTransitionCollection={plannerTransitionHouseholdSummaryCollection}
        setPlannerTransitionCollection={setPlannerTransitionHouseholdSummaryCollection}
        plannerTransitionCollectionLoading={plannerTransitionHouseholdSummaryLoading}
      />
      <PlannerTransitionTableContent
        plannerTransitionCollection={plannerTransitionHouseholdSummaryCollection}
        loading={!plannerTransitionHouseholdSummaryCollection}
        loadingError={plannerTransitionHouseholdSummaryLoadingError}
        onPaginationChange={handlePaginationChange}
        currentPageNumber={currentPageNumber}
        hasNextPage={!!plannerTransitionHouseholdSummaryCollection?.link('next')}
        loadingPrevOrNextPage={loadingPrevOrNextPage}
      />
    </FDBox>
  );
};

PlannerTransitionTable.defaultProps = {
};

PlannerTransitionTable.propTypes = {
};

export default PlannerTransitionTable;
